import React from 'react'

import FooterContainer from './containers/FooterContainer'

const Footer = () => <FooterContainer />

export default Footer
